module.exports = __webpack_public_path__ + "img/commander4x.61b7e556.png";